import Header from '../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../utils/Loader';
import { useGetEnrollmentStatisticsQuery } from "../../Services/api";
import {pageUrl} from "../../utils/constants/constants";

export default function EnrollmentStatistics() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getEnrollmentStatistics,
        isLoading: isGetLoading,
      } = useGetEnrollmentStatisticsQuery({ pageUrl, params:  {search}  });
      if(isGetLoading) return  <Loader></Loader>
    return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title"> Enrollment Statistics</h5>
                    
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    {
                                        getEnrollmentStatistics?.data?.map((item) => {
                                            if(item.cgroup==1){
                                                return (
                                                    <div className="col-lg-3 " key={item.course_id}>
                                                        <div className="card bg-warning">
                                                            <div className="card-body table-responsive">
                                                                <h4 className="card-title">{item.course_name}</h4>
                                                                <p className="card-title">Course : {item.enrollment_count}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else if(item.cgroup==2){
                                                return (
                                                    <div className="col-lg-3 " key={item.course_id}>
                                                        <div className="card bg-info">
                                                            <div className="card-body table-responsive">
                                                                <h4 className="card-title">{item.course_name}</h4>
                                                                <p className="card-title">Course : {item.enrollment_count}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }else if(item.cgroup==3){
                                                return (
                                                    <div className="col-lg-3 " key={item.course_id}>
                                                        <div className="card bg-secondary">
                                                            <div className="card-body table-responsive">
                                                                <h4 className="card-title">{item.course_name}</h4>
                                                                <p className="card-title">Course : {item.enrollment_count}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            
                                        })
                                    }
                                    
                                </div>
                            </section>  
                        </div>
                     
                    </div>
                </div>
            </div>
            </main>
           
        </div>
    );
}
